import {
    Button,
    Dialog,
    DialogActions, DialogBody,
    DialogContent, DialogSurface, DialogTitle,
    DialogTrigger,
    Field,
    Radio,
    RadioGroup
} from "@fluentui/react-components";
import React, { useState} from "react";
import {RouteContext} from "../../RouteContext";
import {DocumentOnePageSparkleFilled} from "@fluentui/react-icons";
import {Styles} from "./Styles";
import {Column, Row} from "./Layout";

export type UpdateShoppingsStateProps<Table> = RouteContext & {
    onUpdate: (wishState:boolean) => void
}

export default function UpdateShoppingsStateButton<Table>(props: UpdateShoppingsStateProps<Table>) {
    const styles = Styles.useEditorStyles()

    const [wishState, setWishState] = useState<boolean>(false)

    return <>
        <Dialog>
            <DialogTrigger disableButtonEnhancement>
                <Button icon={<DocumentOnePageSparkleFilled/>}>일괄 수정</Button>
            </DialogTrigger>
            <DialogSurface>
                <DialogBody>
                    <DialogTitle>일괄 수정</DialogTitle>
                    <DialogContent>
                        <Column>
                        <Field
                            className={styles.field}
                            label='활성 상태'
                            >
                            <RadioGroup
                                value={wishState.toString()}
                                onChange={
                                    (_, data) => setWishState(data.value === 'true')
                                }>
                                <Radio value="true" label="활성화" />
                                <Radio value="false" label="비활성화" />
                            </RadioGroup>
                        </Field>
                        <Row>
                            <Button
                                appearance={'primary'}
                                onClick={()=>props.onUpdate(wishState)}>
                                완료
                            </Button>
                        </Row>
                    </Column>
                    </DialogContent>
                    <DialogActions>
                        <DialogTrigger disableButtonEnhancement>
                            <Button>취소</Button>
                        </DialogTrigger>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    </>
}